import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
	card: {
		backgroundColor: theme.other.getColor('surface/primary/default'),
		padding: theme.spacing.md,
		borderRadius: theme.radius.md,
		boxShadow:
			'0px 1px 0px 0px rgba(0, 0, 0, 0.05), 0px 1px 0px 0px rgba(0, 0, 0, 0.08) inset, 0px -1px 0px 0px rgba(0, 0, 0, 0.12) inset, -1px 0px 0px 0px rgba(0, 0, 0, 0.08) inset, 1px 0px 0px 0px rgba(0, 0, 0, 0.08) inset;',
	},
	hoverCard: {
		'&:hover': {
			backgroundColor: theme.other.getColor('surface/primary/hover'),
		},
	},
}));
